import {getDefaultPath} from "../../helpers/urlSync";
import actions, {getGridSize, getView} from "./actions";
import {LOCATION_CHANGE} from 'react-router-redux';
import {antdConfigs} from "../../locales/i18n";
import { history } from "../store";
import { AppModalType } from '../../enums/AppModalType';
import { defaultTitle } from "../../dashAppConnected";

const [preCurrent, preOpenKeys] = getDefaultPath();
const dateFormatList = [
    'DD/MM/YYYY',
    'DD.MM.YYYY',
    'DD/MM/YY',
    'DD.MM.YY',
    'D/M/YY',
    'DDMMYY',
    'DDMMYYYY',
    'DD-MM-YYYY',
    'DD-MM-YY',
    'D-M-YY',
];
const monthFormatList = [
    'MM/YYYY',
    'MM/YY',
    'MM.YYYY',
    'MM.YY',
    'MMYYYY',
    'MMYY',
    'MM-YYYY',
    'MM-YY',
];
const appVersion = process.env.REACT_APP_VERSION;
const browserLanguage = window.navigator.language || window.navigator.userLanguage;

function getInitLocale() {
    const storedLocale = localStorage.getItem('locale');
    if (storedLocale && storedLocale !== 'undefined')
        return storedLocale;

    // -> if not found, use Browser Language ->  if not found, default to English
    if (Object.keys(antdConfigs).includes(browserLanguage?.substring(0, 2)))
        return browserLanguage?.substring(0, 2);
    return 'en'; // use localStorage
}
const initInterceptor = {
    isVisible: false,
    type: null,
    wrongPasscode: false,
    action: null,
    items: [],
    settings: [],
    numTries: 0,
    details: null,
};
const initAppModal = {
    [AppModalType.IDLE_MODAL]: {isVisible: false},
    [AppModalType.SESSION_EXPIRED_MODAL]: {isVisible: false},
};

const initState = {
    isPulling: false,
    pullingDepth: 0,
    isPushing: false,
    pushingDepth: 0,
    version: null,
    updateAvailable: false,
    timeoutAvailable: false,

    startDrawer: false,
    startPopover: false,
    websocket: null,
    dataExtractionChannel: null,
    shoeboxBadgeCount: 0,
    shoeboxPageCount: 0,
    universalSmartReconPageCount: 0,

    drawerCollapsedMode: window.innerWidth < 1200,
    drawerOpen: false,

    view: getView(window.innerWidth),
    gridSize: getGridSize(window.innerWidth), // xs, sm, md, lg, xl
    width: window.innerWidth,

    openKeys: preCurrent,
    current: preOpenKeys,
    settings: {},
    dateFormatList,
    monthFormatList,
    // eslint-disable-next-line no-control-regex
    emailRegExp: /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])(\s*\s*(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\]))*$/,
    // eslint-disable-next-line no-control-regex
    emailsRegExp: /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])(\s*,\s*(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\]))*$/i,

    interceptor: initInterceptor,
    prevRoute: undefined,
    currentRoute: null,

    appModal: initAppModal,

    locale: getInitLocale(),
    localeLoaded: false,
    resizeEvent: null,
};

export default function appReducer(state = initState, action = {}) {
    switch (action.type) {
        case actions.APP_START_PULLING:
            return {
                ...state,
                pullingDepth: state.pullingDepth + 1,
                isPulling: true,
            };
        case actions.APP_STOP_PULLING: {
            let pullingDepth = state.pullingDepth - 1;
            if (pullingDepth < 0)
                pullingDepth = 0;
            return {
                ...state,
                pullingDepth,
                isPulling: pullingDepth > 0,
            };
        }
        case actions.APP_START_PUSHING:
            return {
                ...state,
                pushingDepth: state.pushingDepth + 1,
                isPushing: true,
            };
        case actions.APP_STOP_PUSHING: {
            let pushingDepth = state.pushingDepth - 1;
            if (pushingDepth < 0)
                pushingDepth = 0;
            return {
                ...state,
                pushingDepth,
                isPushing: pushingDepth > 0,
            };
        }
        case actions.APP_SET_VERSION:
            if (state.version !== action.version) {
                return {
                    ...state,
                    version: action.version,
                    updateAvailable: appVersion !== action.version,
                };
            }
            return {
                ...state,
                version: action.version,
            };
        case actions.APP_TOGGLE_SESSION_TIMEOUT:
            return {
                ...state,
                timeoutAvailable: action.visible,
            };
        case actions.START_DRAWER_SET:
            return {
                ...state,
                startDrawer: action.visible,
            };
        case actions.START_POPOVER_SET:
            return {
                ...state,
                startPopover: action.visible,
            };
        case actions.APP_SET_WEBSOCKET:
            return {
                ...state,
                websocket: action.websocket,
            };
        case actions.APP_SET_DATA_EXTRACTION_CHANNEL:
            return {
                ...state,
                dataExtractionChannel: action.channel,
            };
        case actions.SHOEBOX_BADGE_COUNT_ADD:
            return {
                ...state,
                shoeboxBadgeCount: state.shoeboxBadgeCount + 1,
            };
        case actions.SHOEBOX_BADGE_COUNT_RESET:
            return {
                ...state,
                shoeboxBadgeCount: initState.shoeboxBadgeCount,
            };
        case actions.SHOEBOX_PAGE_COUNT_ADD:
            return {
                ...state,
                shoeboxPageCount: state.shoeboxPageCount + action.count,
            };
        case actions.SHOEBOX_PAGE_COUNT_RESET:
            return {
                ...state,
                shoeboxPageCount: initState.shoeboxPageCount,
            };
        case actions.UNIVERSAL_SMART_RECON_PAGE_COUNT_ADD:
            return {
                ...state,
                universalSmartReconPageCount: state.universalSmartReconPageCount + action.count,
            };
        case actions.UNIVERSAL_SMART_RECON_PAGE_COUNT_RESET:
            return {
                ...state,
                universalSmartReconPageCount: initState.universalSmartReconPageCount,
            };
        case actions.COLLAPSE_CHANGE:
            return {
                ...state,
                drawerCollapsedMode: !state.drawerCollapsedMode,
            };
        case actions.COLLAPSE:
            return {
                ...state,
                drawerCollapsedMode: true,
            };
        case actions.UNCOLLAPSE:
            return {
                ...state,
                drawerCollapsedMode: false,
            };
        case actions.TOGGLE_DRAWER_FORCED_OPEN:
            return {
                ...state,
                drawerOpen: action.forceState ? action.forceState : !state.drawerOpen,

            };
        case actions.TOGGLE_ALL: {
            const { location } = history;
            // checking 'width' is expensive, only do it when needed (eg: shoebox)
            const pathsToCheckWidth = ['/shoebox'];
            const toDetectWidth = pathsToCheckWidth.some(path => location.pathname.startsWith(path));

            if (state.view !== action.view ||
                state.gridSize !== action.gridSize ||
                (toDetectWidth && state.width !== action.width)
            ) {
                return {
                    ...state,
                    view: action.view,
                    gridSize: action.gridSize,
                    drawerCollapsedMode: action.drawerCollapsedMode,

                    // if toDetectWidth = true, will update based on width (to every pixel)
                    // if toDetectWidth = false, will still update based on view/gridsize breakpoints
                    width: action.width,
                };
            }
            break;
        }
        case actions.CHANGE_OPEN_KEYS:
            return {
                ...state,
                openKeys: action.openKeys,
            };
        case actions.CHANGE_CURRENT:
            return {
                ...state,
                current: action.current,
            };
        case actions.CLEAR_MENU:
            return {
                ...state,
                openKeys: [],
                current: [],
            };

        case actions.OPEN_INTERCEPTOR:
            console.log('aaa actions', action);
            return {
                ...state,
                interceptor: {
                    isVisible: true,
                    type: action.interceptType,
                    message: action.message,
                    items: action.items || [],
                    settings: action.settings || [],
                    action: action.action,
                    numTries: state.interceptor.numTries + 1,
                    details: action.details || {
                        nonSupportedTransactionFees: [],
                        statementNumbers: [],
                    },
                    // nonSupportedTransactionFees: action.nonSupportedTransactionFees || [],
                    // statementNumbers: action.statementNumbers || [],
                },
            };

        case actions.CLOSE_INTERCEPTOR:
            return {
                ...state,
                interceptor: {
                    ...initInterceptor,
                    type: state.interceptor.type,
                },
            };

        case actions.OPEN_APP_MODAL:
            return {
                ...state,
                appModal: {
                    ...state.appModal,
                    [action.modalType]: {
                        isVisible: true,
                    },
                },
            };
        case actions.CLOSE_APP_MODAL:
            return {
                ...state,
                appModal: {
                    ...state.appModal,
                    [action.modalType]: {
                        isVisible: false,
                    },
                },
            };
        case actions.CLOSE_ALL_APP_MODALS:
            return {
                ...state,
                appModal: {
                    ...initAppModal,
                },
            };

        case LOCATION_CHANGE: {
            const newPrevRoute = state.currentRoute;
            const newCurrentRoute = action.payload.location.pathname;

            // newPrevRoute may === newCurrentRoute if its same page, but there's tab change. Eg Products page.
            if (newPrevRoute !== newCurrentRoute)
                document.title = defaultTitle; // fallback title
            return {
                ...state,
                prevRoute: newPrevRoute,
                currentRoute: newCurrentRoute,
            };
        }

        case actions.APP_CHANGE_LOCALE:
            localStorage.setItem('locale', action.locale);
            return {
                ...state,
                locale: action.locale,
            };

        case actions.APP_SET_LOCALE_LOADED:
            return {
                ...state,
                localeLoaded: action.localeLoaded,
            };

        case actions.APP_SET_RESIZE_EVENT:
            return {
                ...state,
                resizeEvent: action.width,
            };

        default:
            return state;
    }
    return state;
}
